module.exports = "<p>dfdf</p>\n<div id=\"myPanoViewer\"></div>"